import React from 'react';

function PlayIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.63794 20.2775V4.67749L20.6379 12.4775L7.63794 20.2775Z"
                fill="black"
            />
        </svg>
    );
}

export default PlayIcon;
